import { createContext, useContext } from "react";
import { IAppContext, IAppState } from "./types";

export const initialAppState: IAppState = {
  blaze: undefined,
  provider: undefined,
};

export const AppStateContext = createContext<IAppContext | undefined>(
  undefined,
);

export const useAppContext = () => {
  const context = useContext(AppStateContext);
  if (context === undefined) {
    throw new Error("useAppContext must be used within AppContextProvider");
  }
  return context;
};
